import { useEffect, useRef, useCallback, Dispatch } from 'react';
import { XUserInteraction } from '@core/utils';

export const useOnPopupCloseRefresh = (
  setCurrentRowData: Dispatch<any> | undefined,
  currentRowDataId: any,
  showPopup: Dispatch<any>,
  customRefreshFn?: any,
  customDataGridRef?: any
): [React.MutableRefObject<any>, () => void] => {
  const dataGridRef = useRef<any>(null);
  const preventFirstLoadRefresh = useRef(true);

  const afterRefresh = useCallback(
    (dgInstance) => {
      dgInstance.endCustomLoading();

      if (!currentRowDataId) return;

      dgInstance.selectRows([currentRowDataId]);

      const data = dgInstance.getSelectedRowsData()[0];

      dgInstance.selectRows([]);

      if (setCurrentRowData) {
        setCurrentRowData(data || {});
      }
    },
    [currentRowDataId, setCurrentRowData]
  );

  const refreshData = useCallback(() => {
    const dgInstance = customDataGridRef
      ? customDataGridRef.current.instance
      : dataGridRef.current.instance;

    const refreshFn = customRefreshFn || dgInstance.refresh;

    if (setCurrentRowData) {
      dgInstance.beginCustomLoading();

      refreshFn()
        .then(() => afterRefresh(dgInstance))
        .catch(XUserInteraction.notifyError);
    } else {
      refreshFn();
    }
  }, [customRefreshFn, setCurrentRowData, afterRefresh]);

  useEffect(() => {
    if (!showPopup && !preventFirstLoadRefresh.current) {
      refreshData();
    } else if (preventFirstLoadRefresh.current) {
      preventFirstLoadRefresh.current = false;
    }
  }, [showPopup]);

  return [dataGridRef, refreshData];
};
